import { ErrorModal } from "@dexteel/mesf-core";
import { Asset } from "@dexteel/mesf-core/dist/models/Asset";
import {
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { getDelayAreas } from "../../pages/delays/delays-report/repositories/DelaysReportRepository";

export const DelayAreaSelector = ({
  value,
  onChange,
  disabled = false,
  isAllOption = true,
}: {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  isAllOption?: boolean;
}) => {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const loadData = async () => {
    setIsLoading(true);
    const resp = await getDelayAreas();
    if (resp.ok) {
      const rows = get(resp, "data.tables[0].rows", []) as Asset[];
      setAssets(rows);
    } else {
      setError(resp.message ?? "Error loading assets");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData().then(() => {});
    return;
  }, []);

  return (
    <>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel
          style={{ fontSize: "clamp(.7rem,.8rem,1rem)" }}
          id="assetSelector"
        >
          Asset
        </InputLabel>
        <Select
          disabled={isLoading || disabled}
          labelId="assetSelector"
          id="assetSelector"
          variant="outlined"
          margin="dense"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value as number)}
          label="Asset"
          inputProps={{
            endAdornment: (
              <>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
              </>
            ),
          }}
        >
          {isAllOption && (
            <MenuItem style={{ fontWeight: "bold" }} value={0}>
              <>All</>
            </MenuItem>
          )}
          {assets?.map((asset: Asset) => (
            <MenuItem key={`logId-${asset.AssetId}`} value={asset.AssetId}>
              <Grid container alignItems="center">
                {asset.AssetName}
              </Grid>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
